import Nav from "./Nav";
import { useState, useEffect } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { searchCustomer, addSale } from "./api";

const AddSales = () => {
  // Form state
  const [form, setForm] = useState({
    Id: "",
    name: "",
    mobile: "",
    area: "",
    Product: "",
    Price: "",
    Sales: "",
    paymentdate: "",
    amount: "",
    Mode: "Daily",
    week: "",
    shift: "E",
    message: 0,
    timing: 10,
  });

  const [search, setSearch] = useState("");

  // Set default Sales + Payment dates
  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    setForm((prev) => ({ ...prev, Sales: today, paymentdate: today }));
  }, []);

  // Query: search customer
  const { data: customers = [] } = useQuery({
    queryKey: ["customers", search],
    queryFn: () => searchCustomer(search),
    enabled: search.length > 0, // only run if user typed something
  });

  // Mutation: add sale
  const mutation = useMutation({
    mutationFn: addSale,
    onSuccess: () => {
      alert("✅ Sale added successfully!");
      resetForm();
    },
  });

  // Reset form after submit
  const resetForm = () => {
    setForm({
      Id: "",
      name: "",
      mobile: "",
      area: "",
      Product: "",
      Price: "",
      Sales: new Date().toISOString().slice(0, 10),
      paymentdate: new Date().toISOString().slice(0, 10),
      amount: "",
      Mode: "Daily",
      week: "",
      shift: "",
      message: 0,
      timing: 10,
    });

    setSearch("");
  };

  // Handle input change
  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  // Handle search selection
  const handleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);

    if (val.split("-").length === 4) {
      const [id, name, area, mobile] = val.split("-");
      setForm((prev) => ({
        ...prev,
        Id: id,
        name,
        area,
        mobile,
      }));
    }
  };

  // Submit
  const handleSubmit = () => {
    if (form.amount === "") {
      form.amount = 0;
    }
    const payload = {
      cid: form.Id,
      pname: form.Product,
      price: form.Price,
      salesdate: form.Sales,
      day: form.week,
      mode: form.Mode,
      balance: form.Price - form.amount,
      paymentdate: form.paymentdate,
      amount: form.amount,
      shift: form.shift,
      message: form.message,
      mobile: form.mobile,
      timing: form.timing,
    };
    mutation.mutate(payload);
  };

  // Weekly/Monthly extra input
  const renderExtraField = () => {
    if (form.Mode === "Weekly") {
      return (
        <div className="form-floating mb-3">
          <select
            className="form-select"
            value={form.week}
            onChange={(e) => handleChange("week", e.target.value)}
          >
            <option value="">Select Day</option>
            <option>sunday</option>
            <option>monday</option>
            <option>tuesday</option>
            <option>wednesday</option>
            <option>thursday</option>
            <option>friday</option>
            <option>saturday</option>
          </select>
          <label>Select Day for Collection</label>
        </div>
      );
    }
    if (form.Mode === "Monthly") {
      return (
        <div className="form-floating mb-3">
          <input
            type="number"
            className="form-control"
            value={form.week}
            onChange={(e) => handleChange("week", e.target.value)}
            placeholder="Enter collection date"
          />
          <label>Select Date for Collection</label>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <Nav />
      <div className="d-flex justify-content-center mt-5 pt-3">
        <div
          className="card shadow-lg p-4"
          style={{ maxWidth: "600px", width: "100%" }}
        >
          <h3 className="text-center text-primary fw-bold mb-4">
            🛒 Add Sales
          </h3>

          {/* Search */}
          <div className="form-floating mb-3">
            <input
              list="customerList"
              className="form-control"
              placeholder="Search customer"
              onChange={handleSearch}
            />
            <datalist id="customerList">
              {customers.map((s, i) => (
                <option key={i}>
                  {s[0] + "-" + s[1] + "-" + s[2] + "-" + s[3]}
                </option>
              ))}
            </datalist>
            <label>Search by Name, Mobile, or Area</label>
          </div>

          {/* Customer Info */}
          <div className="row">
            <div className="col-md-6 mb-3 form-floating">
              <input
                type="text"
                className="form-control"
                value={form.Id}
                disabled
              />
              <label>Customer ID</label>
            </div>
            <div className="col-md-6 mb-3 form-floating">
              <input
                type="text"
                className="form-control"
                value={form.name}
                disabled
              />
              <label>Name</label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3 form-floating">
              <input
                type="text"
                className="form-control"
                value={form.mobile}
                disabled
              />
              <label>Mobile</label>
            </div>
            <div className="col-md-6 mb-3 form-floating">
              <input
                type="text"
                className="form-control"
                value={form.area}
                disabled
              />
              <label>Area</label>
            </div>
          </div>

          {/* Product & Price */}
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={form.Product}
              onChange={(e) => handleChange("Product", e.target.value)}
              placeholder="Product"
            />
            <label>Product</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="number"
              className="form-control"
              value={form.Price}
              onChange={(e) => handleChange("Price", e.target.value)}
              placeholder="Price"
            />
            <label>Price</label>
          </div>

          {/* Dates */}
          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              value={form.Sales}
              onChange={(e) => handleChange("Sales", e.target.value)}
            />
            <label>Sales Date</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="number"
              className="form-control"
              value={form.amount}
              onChange={(e) => handleChange("amount", e.target.value)}
              placeholder="Amount Paid"
            />
            <label>Amount Paid</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              value={form.paymentdate}
              onChange={(e) => handleChange("paymentdate", e.target.value)}
            />
            <label>Next Payment Date</label>
          </div>

          {/* Mode */}
          <div className="form-floating mb-3">
            <select
              className="form-select"
              value={form.Mode}
              onChange={(e) => handleChange("Mode", e.target.value)}
            >
              <option>Daily</option>
              <option>Monthly</option>
              <option>Weekly</option>
              <option>Continue</option>
            </select>
            <label>Payment Mode</label>
          </div>

          {/* Shift */}
          <div className="form-floating mb-3">
            <select
              className="form-select"
              value={form.shift}
              onChange={(e) => handleChange("shift", e.target.value)}
            >
              <option value="">Select Shift</option>
              <option>G</option>
              <option>M</option>
              <option>E</option>
            </select>
            <label>Shift</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={form.timing}
              onChange={(e) => handleChange("timing", e.target.value)}
            />
            <label>Timing</label>
          </div>

          {/* Weekly/Monthly field */}
          {renderExtraField()}

          {/* Checkbox */}
          {/* <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              checked={isChecked}
              onChange={handleCheckboxChange}
              id="msgCheck"
            />
            <label className="form-check-label" htmlFor="msgCheck">
              Message Required
            </label>
          </div> */}

          {/* Submit */}
          <button
            className="btn btn-success w-100 rounded-pill"
            onClick={handleSubmit}
            disabled={mutation.isLoading}
          >
            {mutation.isLoading ? "⏳ Saving..." : "✅ Save Sale"}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddSales;
